// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/tenorite);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
}

*, *:before, *:after {
    box-sizing: border-box;
}

:root {
    --blue-main: #3A57FF;
    --green-main: #3ACB89;
    --sky-blue-main: #00E9FF;
    --gray-main: #C5C5CA;

    --black-text: #292929;
    --white-text: #FFF;

    --gradient-main: linear-gradient(130deg, var(--green-main) 47%, var(--sky-blue-main) 100%);
}

h1, h2, h3, h4, h5, h6 {
    font-family: "ITC Avant Garde", sans-serif;
    font-style: normal;
    color: var(--black-text);
}

p, a, button, li {
    font-family: "Tenorite", sans-serif;
    font-style: normal;
}


/* CLASSES */
.max-width-global {
    max-width: 1920px;
    margin: 0 auto;
    padding-left: 120px;
    padding-right: 120px;
}

.button-blue-global,
.button-green-global {
    border: none;
    padding: 12px 20px;
    border-radius: 100px;
    cursor: pointer;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: .03em;
    color: var(--white-text);
}

.button-blue-global {
    background-color: var(--blue-main);
}

.button-green-global {
    background-color: var(--green-main);
}

.button-blue-global:hover,
.button-green-global:hover {
    opacity: .9;
}


@media screen and (max-width: 1536px) {
    .button-blue-global,
    .button-green-global {
        font-size: 18px;
    }
}

@media screen and (max-width: 1440px) {
    .max-width-global {
        padding-left: 80px;
        padding-right: 80px;
    }
}

@media screen and (max-width: 992px) {
    .max-width-global {
        padding-left: 45px;
        padding-right: 45px;
    }
}

@media screen and (max-width: 576px) {
    .max-width-global {
        padding-left: 20px;
        padding-right: 20px;
    }

    .button-blue-global,
    .button-green-global {
        padding: 10px 14px;
        font-size: 14px;
    }
}`, "",{"version":3,"sources":["webpack://./src/global.css"],"names":[],"mappings":"AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,wBAAwB;IACxB,oBAAoB;;IAEpB,qBAAqB;IACrB,kBAAkB;;IAElB,0FAA0F;AAC9F;;AAEA;IACI,0CAA0C;IAC1C,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;AACtB;;;AAGA,YAAY;AACZ;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;;IAEI,WAAW;AACf;;;AAGA;IACI;;QAEI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;;QAEI,kBAAkB;QAClB,eAAe;IACnB;AACJ","sourcesContent":["@import url('https://fonts.cdnfonts.com/css/tenorite');\n\n* {\n    margin: 0;\n    padding: 0;\n}\n\n*, *:before, *:after {\n    box-sizing: border-box;\n}\n\n:root {\n    --blue-main: #3A57FF;\n    --green-main: #3ACB89;\n    --sky-blue-main: #00E9FF;\n    --gray-main: #C5C5CA;\n\n    --black-text: #292929;\n    --white-text: #FFF;\n\n    --gradient-main: linear-gradient(130deg, var(--green-main) 47%, var(--sky-blue-main) 100%);\n}\n\nh1, h2, h3, h4, h5, h6 {\n    font-family: \"ITC Avant Garde\", sans-serif;\n    font-style: normal;\n    color: var(--black-text);\n}\n\np, a, button, li {\n    font-family: \"Tenorite\", sans-serif;\n    font-style: normal;\n}\n\n\n/* CLASSES */\n.max-width-global {\n    max-width: 1920px;\n    margin: 0 auto;\n    padding-left: 120px;\n    padding-right: 120px;\n}\n\n.button-blue-global,\n.button-green-global {\n    border: none;\n    padding: 12px 20px;\n    border-radius: 100px;\n    cursor: pointer;\n    font-size: 20px;\n    font-weight: 700;\n    letter-spacing: .03em;\n    color: var(--white-text);\n}\n\n.button-blue-global {\n    background-color: var(--blue-main);\n}\n\n.button-green-global {\n    background-color: var(--green-main);\n}\n\n.button-blue-global:hover,\n.button-green-global:hover {\n    opacity: .9;\n}\n\n\n@media screen and (max-width: 1536px) {\n    .button-blue-global,\n    .button-green-global {\n        font-size: 18px;\n    }\n}\n\n@media screen and (max-width: 1440px) {\n    .max-width-global {\n        padding-left: 80px;\n        padding-right: 80px;\n    }\n}\n\n@media screen and (max-width: 992px) {\n    .max-width-global {\n        padding-left: 45px;\n        padding-right: 45px;\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .max-width-global {\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n\n    .button-blue-global,\n    .button-green-global {\n        padding: 10px 14px;\n        font-size: 14px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
